import { type ReactNode } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { DepositPropertyLabel } from './internal/components/DepositPropertyLabel';
import { BestPlaceAnalyticsLabelContainer } from './internal/containers/BestPlaceAnalyticsLabelContainer';
import { CoworkingsBenefitsLabelContainer } from './internal/containers/CoworkingsBenefitsLabelContainer';
import { FromOwnerLabelContainer } from './internal/containers/FromOwnerLabelContainer';
import { FromSuperAgentLabelContainer } from './internal/containers/FromSuperAgentLabelContainer';
import { GoodPriceLabelContainer } from './internal/containers/GoodPriceLabelContainer';
import { NoFeeLabelContainer } from './internal/containers/NoFeeLabelContainer';
import { UniqueForCianLabelContainer } from './internal/containers/UniqueForCianLabelContainer';
import { WithAuctionLabelContainer } from './internal/containers/WithAuctionLabelContainer';

type LabelType =
  // Доступна геоаналитика от BestPlace
  | 'bestPlaceAnalytics'
  // Это выгодно
  | 'coworkingBenefits'
  // Залоговое имущество
  | 'depositProperty'
  // От собственника
  | 'fromOwner'
  // Проверенный собственник
  | 'fromOwnerChecked'
  // От супер агента
  | 'fromSuperAgent'
  // Хорошая цена
  | 'goodPrice'
  // Без комиссии
  | 'noFee'
  // Уникально на Циан
  | 'uniqueForCian'
  // Объект размещён на открытом аукционе
  | 'withAuction';

type LabelContainerProps = {
  type: LabelType;
};

export const LabelContainer = memoWithDisplayName(({ type }: LabelContainerProps): ReactNode => {
  switch (type) {
    case 'fromSuperAgent':
      return <FromSuperAgentLabelContainer />;
    case 'bestPlaceAnalytics':
      return <BestPlaceAnalyticsLabelContainer />;
    case 'coworkingBenefits':
      return <CoworkingsBenefitsLabelContainer />;
    case 'depositProperty':
      return <DepositPropertyLabel />;
    case 'fromOwner':
      return <FromOwnerLabelContainer />;
    case 'goodPrice':
      return <GoodPriceLabelContainer />;
    case 'uniqueForCian':
      return <UniqueForCianLabelContainer />;
    case 'noFee':
      return <NoFeeLabelContainer />;

    case 'withAuction':
      return <WithAuctionLabelContainer />;
    default:
      return null;
  }
}, 'Label');
